import { IIconProps, IIconSize } from "src/components/icons/IconProps";
const SvgEditForm = (props: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size === IIconSize.small ? "0.5em" : props.size === IIconSize.medium ? "0.8em" : props.size === IIconSize.large ? "1.3em" : "0.8em"}
    height={props.size === IIconSize.small ? "0.5em" : props.size === IIconSize.medium ? "0.8em" : props.size === IIconSize.large ? "1.3em" : "0.8em"}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke={props.color ? props.color : "#494949"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
    />
    <path
      stroke={props.color ? props.color : "#494949"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4z"
    />
  </svg>
);
export default SvgEditForm;
